module.exports = __webpack_public_path__ + "img/email_circle.9e50611.svg";